import { injectable } from 'inversify';
import env from '@/Framework/env/env';
import { DomainConfig } from '@/Framework/config/DI/DomainConfig';
import { DataroomTenant } from '@/dataroom/domain/vo/types/DataroomTenant';

@injectable()
export class DataroomDomainConfig extends DomainConfig {
  readonly domains: Record<DataroomTenant, string> = {
    dealvdr: env('TENANT_DEALVDR___DATAROOM__DOMAIN'),
    '17g5': env('TENANT_17G5___DATAROOM__DOMAIN'),
    investorset: env('TENANT_INVESTORSET___DATAROOM__DOMAIN'),
    verisend: env('TENANT_VERISEND___DATAROOM__DOMAIN'),
    researchroom: env('TENANT_RESEARCHROOM___DATAROOM__DOMAIN'),
  };

  getDomain(tenant: DataroomTenant): string {
    const domain = this.domains[tenant];

    if (!domain) {
      throw new Error(`No domain found for tenant: ${ tenant }`);
    }
    return domain;
  }
}
